import cookies from 'js-cookie';
import { select, selectAll, each } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import { alertsApi, removeErrors } from './api';
import { regex } from '../shared/constants/validation';
import { createError, removeError } from '../shared/formErrors';
import loadingMixin from '../shared/vue/mixins/loading';
import dataLayerPush from '../shared/utils/analytics';

const addBillPaymentAlertEmailValidationCountCookieName = 'addBillPaymentAlertEmailValidationCount';
const addOutageAlertEmailValidationCountCookieName = 'addOutageAlertEmailValidationCount';
const powerAlerts = select('[data-vue-app="power-alerts"]');
const billAlerts = select('[data-vue-app="bill-alerts"]');
let powerAlertApp = null;
let billAlertApp = null;

function formatPhone(phone) {
  // format phone if it's not already
  const s2 = ("" + phone).replace(/\D/g, ''); // eslint-disable-line prefer-template
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3]; // eslint-disable-line prefer-template
}

const methods = {
  addAlertSubscription() {
    let hasError = false;

    // validate Contact Method has been selected
    if (!this.contactMethod) {
      createError(this.$refs.contactMethod, this.$refs.contactMethodError, 'Please select a contact method.');
      hasError = true;
    } else {
      removeError(this.$refs.contactMethod, this.$refs.contactMethodError);
    }

    // validate email is valid format
    if (this.showEmail) {
      if (!this.contactInformation) {
        createError(this.$refs.contactInfo, this.$refs.contactInfoError, 'Please provide an email address.');
        hasError = true
      } else if (!regex.email.test(this.$refs.contactInfo.value)) {
        createError(this.$refs.contactInfo, this.$refs.contactInfoError, 'Please provide a valid email address.');
        hasError = true
      } else {
        removeError(this.$refs.contactInfo, this.$refs.contactInfoError);
      }
    }

    // validate phone is provided and is valid format
    if (this.showPhone) {
      if (!this.contactInformation) {
        createError(this.$refs.contactInfo, this.$refs.contactInfoError, 'Please provide a phone number.');
        hasError = true
      } else if (!regex.phone.test(this.contactInformation)) {
        // format it the number is at least the right amount of digits
        // and then we can double check the regex again
        if (this.contactInformation.length === 10) {
          this.contactInformation = formatPhone(this.contactInformation);
          if (!regex.phone.test(this.contactInformation)) {
            createError(this.$refs.contactInfo, this.$refs.contactInfoError, 'Please provide a valid phone number.');
            hasError = true
          } else {
            removeError(this.$refs.contactInfo, this.$refs.contactInfoError);
          }
        } else {
          // if the number entered isn't even the right amount of numbers, error
          createError(this.$refs.contactInfo, this.$refs.contactInfoError, 'Please provide a valid phone number.');
          hasError = true
        }
      } else {
        removeError(this.$refs.contactInfo, this.$refs.contactInfoError);
      }
    }

    if (!hasError) {
      this.loading = true;
      this.emailValidationFailed = false;
      const alertSubscription = {
        id: null,
        contactInformation: this.contactInformation,
        contactMethod: this.contactMethod,
        time: this.time,
        type: this.alertType,
        emailValidationFailedCount: this.emailValidationFailedCount,
      };

      if (alertSubscription.contactMethod === "Text" || alertSubscription.contactMethod === "VoiceCall") {
        alertSubscription.contactInformation = alertSubscription.contactInformation.replace(/\D/g, "");
      }

      if (window.fabricator) {
        if (this.alerts.filter((item) => item.contactMethod === alertSubscription.contactMethod && item.contactInformation === alertSubscription.contactInformation).length > 0) {
          this.showDuplicateAlertMessage(alertSubscription.type);
          this.loading = false;
        } else {
          this.alerts.push(alertSubscription);
          // reset alert subscription fields
          this.id = this.getMaxAlertId();
          this.contactMethod = null;
          this.time = "anytime";
          this.contactInformation = null;
          this.agree = false;
          this.showAddAlertMessage(alertSubscription.type);

          this.loading = false;
        }
      } else {
        const duplicateAlerts = this.alerts.filter((item) => item.contactMethod === alertSubscription.contactMethod && item.contactInformation === alertSubscription.contactInformation);

        if (duplicateAlerts.length > 0) {
          this.showDuplicateAlertMessage(alertSubscription.type);
          this.loading = false;
        } else {
          alertsApi.addAlertSubscription(alertSubscription)
            .then(() => {
              this.alerts.push(alertSubscription);
              this.showAddAlertMessage(alertSubscription.type);

              // push GTM events to the data layer
              if (alertSubscription.contactMethod === 'Email') {
                dataLayerPush('EmailEnroll');
              } else if (alertSubscription.contactMethod === 'Text') {
                dataLayerPush('TextEnroll');
              } else if (alertSubscription.contactMethod === 'VoiceCall') {
                dataLayerPush('VoiceEnroll');
              }

              // reset alert subscription fields
              this.id = null;
              this.contactMethod = null;
              this.time = "anytime";
              this.contactInformation = null;
              this.agree = false;
              this.loading = false;
              this.updateIsEnrolledInAlerts(this, true, false);
            })
            .catch((err) => {
              if (err.response && err.response.status === 400) {
                this.noAccountsFound = true;
              }
              this.loading = false;
              if (err.response.status === 400 && err.response.data.error.code === 1060) {
                removeErrors();
                this.emailValidationFailed = true;
                this.emailValidationFailedCount = this.emailValidationFailedCount + 1;
                if (this._data.alertType === 'Power') {
                  cookies.set(addOutageAlertEmailValidationCountCookieName, this.emailValidationFailedCount);
                } else {
                  cookies.set(addBillPaymentAlertEmailValidationCountCookieName, this.emailValidationFailedCount);
                }
              }
              console.log(err);
            });
        }
      }
    }
  },
  deleteAlertConfirm(alertId, alertType, contactMethod) {
    const alertSubscription = {
      id: alertId,
      contactMethod,
      type: alertType,
    };

    this.selectedAlertSubscription = alertSubscription;
    this.deleteAlertModalIsOpen = true;
  },
  deleteAlertSubscription() {
    this.loading = true;

    if (window.fabricator) {
      this.alerts = this.alerts.filter((item) => item.id !== this.selectedAlertSubscription.id || item.contactMethod !== this.selectedAlertSubscription.contactMethod);
      this.showDeleteAlertMessage(this.selectedAlertSubscription.type);
      this.deleteAlertModalIsOpen = false;
      this.loading = false;
    } else {
      alertsApi.deleteAlertSubscription(this.selectedAlertSubscription)
        .then(() => {
          const alertContactMethod = this.selectedAlertSubscription.contactMethod;
          this.alerts = this.alerts.filter((item) => item.id !== this.selectedAlertSubscription.id || item.contactMethod !== this.selectedAlertSubscription.contactMethod);
          this.showDeleteAlertMessage(this.selectedAlertSubscription.type);

          // push GTM events to the data layer
          if (alertContactMethod === 'Email') {
            dataLayerPush('EmailUnenroll');
          } else if (alertContactMethod === 'Text') {
            dataLayerPush('TextUnenroll');
          } else if (alertContactMethod === 'VoiceCall') {
            dataLayerPush('VoiceUnenroll');
          }

          this.deleteAlertModalIsOpen = false;
          this.loading = false;
          this.updateIsEnrolledInAlerts(this, false, true);
        })
    }
  },
  updateAlertSubscription() {
    this.loading = true;

    const alertSubscription = {
      id: null,
      contactInformation: this.contactInformation,
      contactMethod: this.contactMethod,
      time: this.time,
    };

    alertsApi.updateAlertSubscription(alertSubscription).then(() => {
      this.alerts.push({
        id: this.id,
        contactInformation: this.contactInformation,
        contactMethod: this.contactMethod,
        time: this.time,
      });

      this.id = null;
      this.contactMethod = '';
      this.time = '';
      this.contactInformation = '';
    });

    this.loading = false;
  },
  postSubmit() {
    console.log(`API Request here for ${this.alertType}`);
  },
  formatContactInformation(alert) {
    if (alert.contactMethod === "Text" || alert.contactMethod === "VoiceCall") {
      const s2 = ("" + alert.contactInformation).replace(/\D/g, ''); // eslint-disable-line prefer-template
      const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3]; // eslint-disable-line prefer-template
    }
    return alert.contactInformation;
  },
  formatContactTime(alert) {
    if (alert.contactMethod === "VoiceCall") {
      return alert.time;
    }
    return '';
  },
  getMaxAlertId() {
    let clone = {};

    if (this.alerts) {
      clone = this.alerts.slice(0);

      clone.sort((x, y) => {
        if (x['id'] === y['id']) {
          return 0;
        } else if (parseInt(x['id'], 10) < parseInt(y['id'], 10)) {
          return 1;
        }

        return -1;
      });

      return clone.slice(0, 1).id;
    }

    return 1;
  },
  resetAlertMessage() {
    if (powerAlertApp) {
      powerAlertApp.isOutageAlertAddSuccess = false;
      powerAlertApp.isOutageAlertDeleteSuccess = false;
      powerAlertApp.isDuplicatePowerAlertError = false;
    }
    if (billAlertApp) {
      billAlertApp.isBillAlertAddSuccess = false;
      billAlertApp.isBillAlertDeleteSuccess = false;
      billAlertApp.isDuplicateBillAlertError = false;
    }
  },
  showAddAlertMessage(alertType) {
    this.resetAlertMessage();

    if (alertType === 'Billing') {
      billAlertApp.isBillAlertAddSuccess = true;
    } else {
      powerAlertApp.isOutageAlertAddSuccess = true;
    }
  },
  showDeleteAlertMessage(alertType) {
    this.resetAlertMessage();

    if (alertType === 'Billing') {
      billAlertApp.isBillAlertDeleteSuccess = true;
    } else {
      powerAlertApp.isOutageAlertDeleteSuccess = true;
    }
  },
  showDuplicateAlertMessage(alertType) {
    this.resetAlertMessage();

    if (alertType === 'Billing') {
      billAlertApp.isDuplicateBillAlertError = true;
    } else {
      powerAlertApp.isDuplicatePowerAlertError = true;
    }
  },
  updateIsEnrolledInAlerts(alertApp, added, removed) {
    const alertCount = alertApp && alertApp._data && alertApp._data.alerts ? alertApp._data.alerts.length : 0;
    let manageAlertsStatusBubbles = selectAll(".billpayment-alerts-status-bubble");
    if (alertApp._data.alertType === 'Power') {
      manageAlertsStatusBubbles = selectAll(".outage-alerts-status-bubble");
    }
    if (added && alertCount === 1) {
      alertsApi.updateIsAlertsEnrolled(true, alertApp._data.alertType);
      each(manageAlertsStatusBubbles, manageAlertsStatusBubble => {
        manageAlertsStatusBubble.classList.add('status-bubble--on');
      });
    } else if (removed && alertCount === 0) {
      alertsApi.updateIsAlertsEnrolled(false, alertApp._data.alertType);
      each(manageAlertsStatusBubbles, manageAlertsStatusBubble => {
        manageAlertsStatusBubble.classList.remove('status-bubble--on');
      });
    }
  },
}

if (powerAlerts) {
  powerAlertApp = new Vue({ // eslint-disable-line no-new
    delimiters,
    el: powerAlerts,
    mixins: [loadingMixin],
    data: {
      alertType: 'Power',
      alerts: window.VueTables ? window.VueTables.powerAlertSubscriptions : [
        { id: '', contactMethod: 'Text (SMS)', time: '9:00am - 12:00pm', contactInformation: '(440) 665-9875', type: 'Power' },
      ],
      id: null,
      contactMethod: null,
      contactInformation: null,
      time: "anytime",
      agree: false,
      modalIsOpen: false,
      selectedAlertSubscription: null,
      deleteAlertModalIsOpen: false,
      powerAlertTermsModalIsOpen: false,
      maxAlertsPerMethod: window.VueTables ? window.VueTables.maxAlertsPerMethod : 6,
      isOutageAlertAddSuccess: false,
      isOutageAlertDeleteSuccess: false,
      isDuplicatePowerAlertError: false,
      emailValidationFailed: false,
      emailValidationFailedCount: 0,
    },
    mounted() {
      this.emailValidationFailedCount = cookies.get(addOutageAlertEmailValidationCountCookieName) ? JSON.parse(cookies.get(addOutageAlertEmailValidationCountCookieName)) : 0;
    },
    computed: {
      showEmail() {
        return !this.showPhone;
      },
      showPhone() {
        return (this.contactMethod === "Text") || (this.contactMethod === "VoiceCall");
      },
      hasMaxForSelectedContactMethod() {
        return this.alerts.filter((a) => a.contactMethod === this.contactMethod).length >= this.maxAlertsPerMethod;
      },
      disableAdd() {
        return !this.agree || !this.contactMethod || this.contactMethod === '' || !this.contactInformation || this.hasMaxForSelectedContactMethod || this.emailValidationFailedThresholdLimitReached;
      },
      emailValidationFailedThresholdLimitReached() {
        return this.emailValidationFailedCount >= 3;
      },
    },
    watch: {
      contactMethod() {
        this.contactInformation = null;
        removeError(this.$refs.contactInfo, this.$refs.contactInfoError);
      },
      contactInformation() {
        if (this.contactMethod === "Text" || this.contactMethod === "VoiceCall") {
          const pattern = /^\(\d{3}\) \d{3}-\d{4}$/
          if (!pattern.test(this.contactInformation)) {
            if (!(/^\(\d{0,3}\) \d{3}-\d{4}$/.test(this.contactInformation) || /^\(\d{3}\) \d{0,3}-\d{4}$/.test(this.contactInformation) || /^\(\d{3}\) \d{3}-\d{0,4}$/.test(this.contactInformation))) {
              if (!(/^\(\d{0,3}\) \d{3}-\d{4}$/.test(this.contactInformation) || /^\(\d{3}\) \d{0,3}-\d{4}$/.test(this.contactInformation) || /^\(\d{3}\) \d{3}-\d{0,4}$/.test(this.contactInformation))) {
                const s2 = (`${this.contactInformation}`).replace(/\D/g, '');
                const m1 = s2.slice(0, 3);
                const m2 = s2.slice(3, 6);
                const m3 = s2.slice(6, 10);
                let contactInformation = "";
                contactInformation += (m1 === "" ? "" : `(${m1}`);
                contactInformation += (m2 === "" ? "" : `) ${m2}`);
                contactInformation += (m3 === "" ? "" : `-${m3}`);
                this.contactInformation = contactInformation;
              }
            }
          }
        }
      },
    },
    methods,
    created() {
      Event.$on('A11yDialogConfirm:confirm-power-alert-delete', () => {
        this.deleteAlertSubscription();
      });
    },
  });
}

if (billAlerts) {
  billAlertApp = new Vue({ // eslint-disable-line no-new
    delimiters,
    el: billAlerts,
    mixins: [loadingMixin],
    data: {
      alertType: 'Billing',
      alerts: window.VueTables ? window.VueTables.billingAlertSubscriptions : [
        { id: 1, contactMethod: 'Text (SMS)', time: '9:00am - 12:00pm', contactInformation: '(440) 665-9875', type: 'Billing' },
      ],
      id: null,
      contactMethod: null,
      contactInformation: null,
      time: "anytime",
      agree: false,
      selectedAlertSubscription: null,
      deleteAlertModalIsOpen: false,
      billAlertTermsModalIsOpen: false,
      maxAlertsPerMethod: window.VueTables ? window.VueTables.maxAlertsPerMethod : 6,
      autopayEnrolled: window.autopayEnrolled ? window.autopayEnrolled : false,
      isBillAlertAddSuccess: false,
      isBillAlertDeleteSuccess: false,
      isDuplicateBillAlertError: false,
      emailValidationFailed: false,
      emailValidationFailedCount: 0,
    },
    mounted() {
      this.emailValidationFailedCount = cookies.get(addBillPaymentAlertEmailValidationCountCookieName) ? JSON.parse(cookies.get(addBillPaymentAlertEmailValidationCountCookieName)) : 0;
    },
    computed: {
      showEmail() {
        return !this.showPhone;
      },
      showPhone() {
        return (this.contactMethod === "Text") || (this.contactMethod === "VoiceCall");
      },
      hasMaxForSelectedContactMethod() {
        return this.alerts.filter((a) => a.contactMethod === this.contactMethod).length >= this.maxAlertsPerMethod;
      },
      disableAdd() {
        return !this.agree || !this.contactMethod || this.contactMethod === '' || !this.contactInformation || this.hasMaxForSelectedContactMethod || this.emailValidationFailedThresholdLimitReached;
      },
      emailValidationFailedThresholdLimitReached() {
        return this.emailValidationFailedCount >= 3;
      },
    },
    watch: {
      contactMethod() {
        this.contactInformation = "";
        removeError(this.$refs.contactInfo, this.$refs.contactInfoError);
      },
      contactInformation() {
        if (this.contactMethod === "Text" || this.contactMethod === "VoiceCall") {
          const pattern = /^\(\d{3}\) \d{3}-\d{4}$/
          if (!pattern.test(this.contactInformation)) {
            if (!(/^\(\d{0,3}\) \d{3}-\d{4}$/.test(this.contactInformation) || /^\(\d{3}\) \d{0,3}-\d{4}$/.test(this.contactInformation) || /^\(\d{3}\) \d{3}-\d{0,4}$/.test(this.contactInformation))) {
              const s2 = (`${this.contactInformation}`).replace(/\D/g, '');
              const m1 = s2.slice(0, 3);
              const m2 = s2.slice(3, 6);
              const m3 = s2.slice(6, 10);
              let contactInformation = "";
              contactInformation += (m1 === "" ? "" : `(${m1}`);
              contactInformation += (m2 === "" ? "" : `) ${m2}`);
              contactInformation += (m3 === "" ? "" : `-${m3}`);
              this.contactInformation = contactInformation;
            }
          }
        }
      },
    },
    methods,
    created() {
      Event.$on('A11yDialogConfirm:confirm-billing-alert-delete', () => {
        this.deleteAlertSubscription();
      });
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/alerts.js